{
  "summary": "Resumen",
  "employees": "Empleados",
  "payments": "Pagos",
  "default_fees": "Tarifas Predeterminadas",
  "primary": "Primario",
  "commitment": "Compromiso",
  "payment": "Pago",
  "cpl": "CPL",
  "post-processing": "Posprocesamiento",
  "loss-payee": "Beneficiario de pérdidas",
  "mailing": "Envío",
  "if-you-leav": "Si abandona esta página, sus cambios no se guardarán",
  "it-is-necessary-to-save": "Es necesario guardar todos los cambios en esta sección, por favor guárdelos antes de regresar a la orden.",
  "loan-processor": "procesador de préstamos",
  "edit-employee": "Editar empleado",
  "not-employees-added": "Aún no se agregaron empleados para esta empresa.",
  "work-number": "Numero del trabajo",
  "phone-number": "Numero de Telefono",
  "actions": "Acciones",
  "loan-originator": "Originador de préstamos",
  "assistant": "Asistente",
  "refinance": "Refinanciar",
  "heloc": "HELOC",
  "routing": "Enrutamiento",
  "account": "Cuenta",
  "check": "Cheque",
  "holdback": "Retenido",
  "wire": "Transferencia",
  "borrower": "Prestatario",
  "application": "Applicacion",
  "appraisal": "Evaluación",
  "assignment-consideration": "Consideración de asignación",
  "courier": "Mensajero",
  "credit-report": "Reporte de crédito",
  "document-preparation": "Preparación del documento",
  "e-recording-fee": "Tarifa de grabación electrónica",
  "endorsement": "Aprobación",
  "flood-certification": "Certificación de inundaciones",
  "hazard-insurance": "Seguro contra riesgos",
  "home-warranty": "Garantía del hogar",
  "insurance": "Seguro",
  "lenders-policy": "Política del prestamista",
  "notary": "Notario",
  "origination": "Origen",
  "owners_policy": "Política del propietario",
  "payoff": "Saldar",
  "property-owners-association-resale-certificate": "Asociación de propietarios - Certificado de reventa",
  "property-owners-association-transfer-fee": "Asociación de propietarios - Tarifa de transferencia",
  "property-tax": "Impuesto sobre la propiedad",
  "real-estate-agent-commission": "Comisión de agente inmobiliario",
  "real-estate-broker-commission": "Comisión del corredor de bienes raíces",
  "recording-fee": "Tarifa de grabación",
  "reimbursement": "Reembolso",
  "remittance-endorsment": "Remesa: Endoso",
  "remittance-ltp": "Remesa: LTP",
  "remittance-otp": "Remesa: OTP",
  "sales-tax": "Impuesto de venta",
  "seller-finance": "Finanzas del vendedor",
  "settlement-fee": "Tarifa de liquidación",
  "survey": "Encuesta",
  "tax-certificate": "Certificado de impuestos",
  "tiga": "TIGA",
  "transfer-tax": "Impuesto de transferencia",
  "wire-fee": "Honorario de transferencia",
  "excluded": "Excluido",
  "unclassified": "Desclasificado",
  "construction_binder": "Aglutinante de construcción",
  "section": "Sección",
  "description": "Descripcion",
  "payee": "Tenedor",
  "amount": "Monto",
  "none": "Ninguno",
  "tax-service": "Servicio de impuesto",
  "companyEmployees": "Empleados de {{company}}",
  "createNewEmployeeAt": "Crear Nuevo Empleado en {{company}}"
}
